import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-8', 'Number8', [["path",{"d":"M8 8a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"}],["path",{"d":"M8 16a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"}]]);